import React from 'react';

export default class FlagIcon extends React.Component {
    static propTypes = {
        iso: React.PropTypes.string.isRequired
    };
    render() {
        return (
            <i className={`flag flag-${this.props.iso}`} style={this.props.style}></i>
        );
    }
}




// WEBPACK FOOTER //
// ./app/components/FlagIcon.js